import {Component} from "react";
import "../styles/App.scss";
import LandingPage from "./LandingPage";
import 'react-app-polyfill/ie9';
import initialize from './utils/banner';

class App extends Component {
    constructor() {
        super();
        initialize();
    }

    render() {
        return (
            <div className="App">
                <LandingPage/>
            </div>
        );
    }
}

export default App;
